<section class="page-intro faq-page">
  <p class="kicker">CapiTrade</p>
  <h1>{{ lang.t('faqTitle') }}</h1>
  <p class="lede">{{ lang.t('faqIntro') }}</p>
  <div class="faq-list">
    @for (item of lang.faqs(); track item.q; let index = $index) {
      <article>
        <button type="button" [attr.aria-expanded]="open() === index" (click)="toggle(index)">
          {{ item.q }}
          <span aria-hidden="true">{{ open() === index ? '−' : '+' }}</span>
        </button>
        @if (open() === index) {
          <p>{{ item.a }}</p>
        }
      </article>
    }
  </div>
</section>
